(function () {
  const SELECTOR = '[data-reveal]';
  const READY_CLASS = 'reveal-ready';
  const VISIBLE_CLASS = 'is-revealed';

  function getEls(root) {
    return Array.from((root || document).querySelectorAll(SELECTOR));
  }

  function markReady(els) {
    els.forEach(el => el.classList.add(READY_CLASS));
  }

  function initReveal(root = document) {
    const els = getEls(root);
    if (!els.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    markReady(els);

    if (reduceMotion) {
      els.forEach(el => el.classList.add(VISIBLE_CLASS));
      return;
    }

    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;

          // 下一帧再加 class，保证 transition 一定触发
          requestAnimationFrame(() => {
            entry.target.classList.add(VISIBLE_CLASS);
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    els.forEach(el => io.observe(el));
  }

  // 首次加载
  document.addEventListener('DOMContentLoaded', () => initReveal());

  // 浏览器 bfcache 返回也要初始化一次
  window.addEventListener('pageshow', () => initReveal());

  // Theme Editor
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));

  // 一些主题会用局部替换 main content（view transitions / ajax 导航）
  document.addEventListener('shopify:page:load', () => initReveal());
})();
